/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Word_TitleInputs */



/**
* | output |
* | --- |
* | "Word, as before" |
*
* @param {Pitch_Word_TitleInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_word_title = /** @type {((inputs?: Pitch_Word_TitleInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Word_TitleInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Word, as before")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Word, som förut")
	return /** @type {LocalizedString} */ ("Word, som før")
});